// extracted by mini-css-extract-plugin
export default {"wrapper":"Inputs_wrapper__4v9pG","title":"Inputs_title__5IIrt","input-wrapper":"Inputs_input-wrapper__AbYbX","input":"Inputs_input__hfRmd","send-button":"Inputs_send-button__juNWM"};